// Querys and Mutations
import {
  CREATE,
  UPDATE,
  GET_WITH_PAGINATION,
  DELETE,
  GET_ALL
} from '@/graphql/dailyControl/PermissionControlGraphql'

// models
import { ResponseDefault, ResponseCustom, Paginator } from '@/models'
import {
  PermissionControlModel,
  PermissionControlsWithPagination,
  PermissionControlForm,
  FiltersPermissionControl
} from '@/models/dailyControl'

// apollo
import { apolloClient } from '@/apollo'
import { getFirstErrorApollo } from '@/utils/apollo'

const filtersDefault: FiltersPermissionControl = {
    dateEnd: null,
    dateStart: null,
    employee: null,
    reason: null
}

class PermissionControlsService {
  /**
   * Queries
   */
  async getWithPagination (perPage = 10, page = 1, filters: FiltersPermissionControl): Promise<PermissionControlsWithPagination> {
      const result = await apolloClient.query({
          query: GET_WITH_PAGINATION,
          variables: {
            page: page,
            perPage: perPage,
            filters: {
                ...filters,
                employee: filters.employee ? Number(filters.employee) : null,
                reason: filters.reason ? Number(filters.reason) : null
            }
          }
      })
      const pagination: Paginator = result.data.permissionControlsWithPagination.paginatorInfo
      const data: PermissionControlModel[] = result.data.permissionControlsWithPagination.data
      const response: PermissionControlsWithPagination = {
          objects: data,
          pagination: pagination
      }
      return response
  }

  async getAll (filters: FiltersPermissionControl = filtersDefault): Promise<PermissionControlModel[]> {
      const result = await apolloClient.query({
          query: GET_ALL,
          variables: {
            filters: {
                ...filters,
                employee: filters.employee ? Number(filters.employee) : null,
                reason: filters.reason ? Number(filters.reason) : null
            }
          }
      })
      return result.data.permissionControls
  }

  /**
   * Mutations
   */
    create (form: PermissionControlForm): Promise<ResponseCustom> {
        return apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        }).then(() => {
            return {
                success: true,
                msg: 'success'
            }
        }).catch(e => {
            throw getFirstErrorApollo(e)
        })
    }

    update (id: number, form: PermissionControlForm): Promise<ResponseCustom> {
        return apolloClient.mutate({
            mutation: UPDATE,
            variables: {
            id: id,
              input: form
            }
        }).then(() => {
            return {
                success: true,
                msg: 'sucess'
            }
        }).catch(e => {
            throw getFirstErrorApollo(e)
        })
    }

  async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
  }
}

export default new PermissionControlsService()
